
const routes = [
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: "Home",
        path: "",
        meta: { title: "mainMenu.home" },
        requiresAuth: true,
        component: () => import("pages/Index.vue"),
      },
      {
        name: "BffResourceMap",
        path: "/bff-resource-map",
        meta: { entityStoreId: 'bffResource', viewType: 'graphView' },
        requiresAuth: true,
        component: () => import("../pages/BffResourceMap.vue"),
      },
      {
        name: "BffResources",
        path: "/bff-resources",
        meta: { entityStoreId: 'bffResource' },
        requiresAuth: true,
        component: () => import("../pages/BffResourceTable.vue"),
      },
      {
        name: "Asset status",
        path: "/asset-status",
        meta: { entityStoreId: 'asset', viewType: 'mapView' },
        requiresAuth: true,
        component: () => import("pages/AssetMap.vue"),
      },
      {
        name: "Assets",
        path: "/assets/:assetId?",
        meta: { entityStoreId: 'asset' },
        requiresAuth: true,
        component: () => import("pages/AssetTable.vue"),
      },
      {
        name: "Asset history",
        path: "/assets/:assetId?/asset-history",
        meta: { entityStoreId: 'asset' },
        requiresAuth: true,
        component: () => import("pages/AssetHistory.vue"),
      },
      {
        name: "Asset types",
        path: "/asset-types",
        meta: { entityStoreId: 'assetType' },
        requiresAuth: true,
        component: () => import("pages/AssetTypeTable.vue"),
      },
      {
        name: "Sensor types",
        path: "/sensor-types",
        meta: { entityStoreId: 'sensorType' },
        requiresAuth: true,
        component: () => import("pages/SensorTypeTable.vue"),
      },
      {
        name: "Drivers",
        path: "/drivers",
        meta: { entityStoreId: 'driver' },
        requiresAuth: true,
        component: () => import("pages/DriverTable.vue"),
      },
      {
        name: "Vehicles",
        path: "/vehicles",
        meta: { entityStoreId: 'vehicle' },
        requiresAuth: true,
        component: () => import("pages/VehicleTable.vue"),
      },
      {
        name: "Customers",
        path: "/customers",
        meta: { entityStoreId: 'customer' },
        requiresAuth: true,
        component: () => import("pages/CustomerTable.vue"),
      },
      {
        name: "Workflow schemas",
        path: "/workflow-schemas",
        meta: { entityStoreId: 'workflowSchema' },
        requiresAuth: true,
        component: () => import("pages/WorkflowSchemaTable.vue"),
      },
      {
        name: "Workflows",
        path: "/workflows",
        meta: { entityStoreId: 'workflow' },
        requiresAuth: true,
        component: () => import("pages/WorkflowTable.vue"),
      },
      {
        name: "Simulator",
        path: "/input-streams",
        meta: { entityStoreId: 'inputStream' },
        requiresAuth: true,
        component: () => import("pages/InputStreamTable.vue"),
      },
      {
        name: "About",
        path: "/about",
        meta: { entityStoreId: 'about' },
        requiresAuth: true,
        component: () => import("pages/About.vue"),
      },
      {
        name: "Settings",
        path: "/settings",
        meta: { entityStoreId: 'settings' },
        requiresAuth: true,
        component: () => import("pages/Settings.vue"),
      },
      {
        name: "DisplaySettings",
        path: "/display-settings/:id?",
        requiresAuth: true,
        component: () => import("pages/DisplaySettings.vue"),
      },
    ],
  },

  // /auth/login
  {
    path: "/auth",
    component: () => import("layouts/BlankLayout.vue"),
    children: [
      {
        path: "",
        name: "authentication",
        component: () => import("pages/AuthenticationPage.vue"),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/Error404.vue"),
  },
];

export default routes;
